import { gql } from '@apollo/client';

export default gql`
  mutation OvertimeSendEmail($input: SendOvertimeEmailInput!) {
    sendOvertimeEmail(input: $input) {
      status
    }
  }
`;
